import { FaRegHandshake, FaMinus, FaPlus, FaChessQueen, FaChessKnight, FaChessPawn, FaChevronDown, FaEye, FaEyeSlash, FaCircle, FaCheck, FaSun, FaMoon } from "react-icons/fa";
import { IoHomeOutline, IoArrowBack, IoArrowForward, IoHelpCircleOutline, IoPersonOutline, IoMailOutline, IoExitOutline, IoNewspaperOutline, IoDocumentOutline, IoCopyOutline, IoClose, IoInformationCircleOutline, IoPerson} from "react-icons/io5";
import { BsFileEarmarkWord, BsFiletypePdf, BsCheckCircle, BsArrowRepeat } from "react-icons/bs";
import { GrMapLocation } from "react-icons/gr";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";




const iconMap = {
    'Basic': <FaChessPawn/>,
    'Standard': <FaChessKnight/>,
    'Premium': <FaChessQueen/>,
    'Home': <IoHomeOutline/>,
    'Back': <IoArrowBack/>,
    'Forward': <IoArrowForward/>,
    'User': <IoPersonOutline/>,
    'User_Solid': <IoPerson/>,
    'Signout': <IoExitOutline/>,
    'zip': <GrMapLocation/>,
    'manual': <HiOutlineWrenchScrewdriver/>,
    'Advertising': <IoNewspaperOutline/>,
    'Messages': <IoMailOutline/>,
    'Leases': <IoDocumentOutline/>,
    'Contracts': <FaRegHandshake />,
    'Advice': <IoHelpCircleOutline/>,
    'Word': <BsFileEarmarkWord/>,
    'Pdf': <BsFiletypePdf/>,
    'Copy': <IoCopyOutline/>,
    'Check': <BsCheckCircle/>,
    'Minus': <FaMinus/>,
    'Plus': <FaPlus/>,
    'X': <IoClose size={24}/>,
    'Down': <FaChevronDown/>,
    'Info': <IoInformationCircleOutline/>,
    'Refresh': <BsArrowRepeat/>,
    'Eye': <FaEye/>,
    'Eye_Slash': <FaEyeSlash/>,
    'Circle': <FaCircle/>,
    'Snack_Check': <FaCheck/>,
    'Sun': <FaSun/>,
    'Moon': <FaMoon/>,
}
export default iconMap;